import React from 'react';
import { RouterProvider } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import './reset.css'
import { router } from './router/routes';
import { AuthContextProvider } from './contexts/AuthContext';
import { ThemeContextProvider } from "./contexts/ThemeContext";

createRoot(document.getElementById("root")).render(
  <ThemeContextProvider>
    <AuthContextProvider>
      <RouterProvider router={router} />
    </AuthContextProvider>
  </ThemeContextProvider>
);
